import { render, staticRenderFns } from "./reel_list.vue?vue&type=template&id=0160c1a8&"
import script from "./reel_list.vue?vue&type=script&lang=js&"
export * from "./reel_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports